import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfiguration } from 'components/ProtectedBackendPanel/authProvider';

export const msalInstance = new PublicClientApplication(msalConfiguration);
